import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-question-line text-sm" />
              先问清楚
            </p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-900 md:text-3xl">
              关于免费全解锁，你想知道的都在这里
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于吃瓜免费资源、解锁门槛、更新频率与观看方式，
              我们把常见疑问一次说透，让你吃得放心、看得明白。
            </p>
            <div className="mt-6 flex items-start gap-3 rounded-lg border border-accent-200/70 bg-accent-100/50 p-4">
              <i className="ri-information-line mt-0.5 text-lg text-accent-700" />
              <p className="text-xs leading-relaxed text-accent-900">
                还有疑问？可以直接在下方看看其他条，或直接去热吃区逛逛，
                大多数问题其实点开内容就有答案了。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col gap-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={i}
                    className={`overflow-hidden rounded-lg border transition-colors ${
                      isOpen ? "border-primary-200 bg-primary-50/40" : "border-background-200/70 bg-background-100/40"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 p-4 text-left md:p-5"
                    >
                      <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-700"
                        }`}
                      >
                        <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                      </span>
                    </button>
                    {isOpen && (
                      <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600 md:px-5">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}